import {
  IInternalTicketActionBody,
  IInternalTicketCreateBody,
  IInternalTicketDetail,
  IInternalTicketListItem,
  IInternalTicketServiceOption,
  IInternalTicketShowBody,
} from '../../../interfaces/newStudent/ticket.interface';
import { defaultReturn } from '../../../util/newStudent';
import {
  buildCreateTicketFormData,
  buildTicketActionFormData,
} from '../../../util/newStudent/ticket/ticketFormData';
import * as apiService from '../../api/newStudent/apiStudent.service';

export const ticketsServiceNewStudent = {
  async show(body: IInternalTicketShowBody): Promise<{
    data: IInternalTicketListItem[];
    message: string[];
    result: boolean;
  }> {
    try {
      const request = await apiService.authenticatedRequest(
        '/student/ticket/internal/show',
        'POST',
        body,
      );

      return defaultReturn(request);
    } catch (error) {
      throw new Error(String(error));
    }
  },

  async getServices(): Promise<{
    data: IInternalTicketServiceOption[];
    message: string[];
    result: boolean;
  }> {
    try {
      const request = await apiService.authenticatedRequest(
        '/student/ticket/internal/services',
        'GET',
      );

      return defaultReturn(request);
    } catch (error) {
      throw new Error(String(error));
    }
  },

  async create(
    body: IInternalTicketCreateBody,
    files: File[] = [],
  ): Promise<{
    data: boolean;
    message: string[];
    result: boolean;
  }> {
    try {
      const request = files.length
        ? await apiService.authenticatedRequest(
            '/student/ticket/internal/create',
            'POST',
            buildCreateTicketFormData(body, files),
            'file',
          )
        : await apiService.authenticatedRequest(
            '/student/ticket/internal/create',
            'POST',
            body,
          );

      return defaultReturn(request);
    } catch (error) {
      throw new Error(String(error));
    }
  },

  async editShow(protocol: string): Promise<{
    data: IInternalTicketDetail;
    message: string[];
    result: boolean;
  }> {
    try {
      const request = await apiService.authenticatedRequest(
        `/student/ticket/internal/edit/${protocol}`,
        'GET',
      );

      return defaultReturn(request);
    } catch (error) {
      throw new Error(String(error));
    }
  },

  async newAction(
    body: IInternalTicketActionBody,
    protocol: string,
    files: File[] = [],
  ): Promise<{
    data: boolean;
    message: string[];
    result: boolean;
  }> {
    try {
      const request = files.length
        ? await apiService.authenticatedRequest(
            `/student/ticket/internal/new-action/${protocol}`,
            'POST',
            buildTicketActionFormData(body, files),
            'file',
          )
        : await apiService.authenticatedRequest(
            `/student/ticket/internal/new-action/${protocol}`,
            'POST',
            body,
          );

      return defaultReturn(request);
    } catch (error) {
      throw new Error(String(error));
    }
  },

  async reopen(
    body: IInternalTicketActionBody,
    protocol: string,
    files: File[] = [],
  ): Promise<{
    data: boolean;
    message: string[];
    result: boolean;
  }> {
    try {
      const request = files.length
        ? await apiService.authenticatedRequest(
            `/student/ticket/internal/reopen/${protocol}`,
            'POST',
            buildTicketActionFormData(body, files),
            'file',
          )
        : await apiService.authenticatedRequest(
            `/student/ticket/internal/reopen/${protocol}`,
            'POST',
            body,
          );

      return defaultReturn(request);
    } catch (error) {
      throw new Error(String(error));
    }
  },
};
